import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth-service.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // looking only for login base url;
    if (req.url.includes('https://www.auth.aidwatch.net/auth')) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
      });
      return next.handle(req).pipe(
        catchError(error => {
          return this.authService.wrongCredentials(error);
        })
      );
    }

    return next.handle(req);

  }
}
